import BaseModel from '@/app-core/lib/data/model/BaseModel'
import RegisterResource from '@/app-core/api/resources/user/RegisterResource'
import RegisterValidator from '@/app-core/api/validations/user/RegisterValidator'
import API from '@/app-core/api/Api'
import RegisterSaveResource from '@/app-core/api/resources/user/RegisterSaveResource'

export default class RegisterModel extends BaseModel {
  constructor(payload = {}, resource = RegisterResource, validator = RegisterValidator) {
    super(payload, resource, validator)
  }

  boot() {
    super.boot()

    this.guarded = []
  }

  /* PROPERTIES */

  /* METHODS */
  async Register() {
    const payload = this.clone(false, RegisterSaveResource)
    return await API.Resource.User.Register(payload)
  }
}
